import { render } from "./processedit.vue?vue&type=template&id=70b0b607&scoped=true"
import script from "./processedit.vue?vue&type=script&lang=js"
export * from "./processedit.vue?vue&type=script&lang=js"

import "./processedit.vue?vue&type=style&index=0&id=70b0b607&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b0b607"]])

export default __exports__